import { render, staticRenderFns } from "./InstitutionDashboard.vue?vue&type=template&id=33c5d968&scoped=true&"
import script from "./InstitutionDashboard.vue?vue&type=script&lang=js&"
export * from "./InstitutionDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionDashboard.vue?vue&type=style&index=0&id=33c5d968&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c5d968",
  null
  
)

export default component.exports